export enum PaymentMethod {

  // Kasse / Bar
  CASH = 'CASH',
  // Banküberweisung
  BANK_TRANSFER = 'BANK_TRANSFER',
  // PayPal
  PAYPAL = 'PAYPAL',
  // Skonto / Preisnachlass
  DISCOUNT = 'DISCOUNT',
  // Trinkgeld / Gratifikation / Geldgeschenk
  GRATUITY = 'GRATUITY',
  // None / Leave open / Offen lassen
  // Used for DocumentPaymentEntryDto.remainingAmountActon
  NONE = 'NONE',
}
